module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_13-66c0c0a1f232969c6f940107bc206307.png";